// extracted by mini-css-extract-plugin
export default {"terms-checkbox-star":"terms-checkbox-star_uyR322Vz","required-field":"required-field_CWqU5dtE","padding-center":"padding-center_HA9jcxOP"};